import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { client } from "../../../App";
import { GET_BILL_DETAIL } from "../../../helpers/queries";
import { useHistory } from "react-router-dom";

import './PaymentReceiptModal.scss';
import { useTranslation } from "react-i18next";
import { standardizeGraphQLError } from "../../../helpers/helpers";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import Modal from "../Modal/Modal";

const ValidationTypes = {
  UNSURE: 'unsure',
  VALID: 'valid',
  INVALID: 'invalid',
}

const PaymentModal = ({ isOpen, onClose, desc, buttons, icon, t, valid, setErrors, setValid }) => {
  return isOpen ? (
    <div>
      <Modal
        icon={ icon === "success" ? "gc-icon-functional-check-2-col" : "gc-icon-functional-close-circle-2-col" }
        show={isOpen}
        onClose={onClose}
        content={desc}
        type={"button"}
        linkTitle={t("bills.receipts.back-to-bills")}
        onFirstClick={onClose}
        typeSecond= {valid === ValidationTypes.INVALID ? "button" : null}
        linkTitleSecond={valid === ValidationTypes.INVALID ? t("bills.receipts.update") : null}
        onSecondClick={valid === ValidationTypes.INVALID ?
          () => {
             setErrors([]);
             setValid(ValidationTypes.UNSURE);
           }
        : null }
      />
    </div>
  ) : null;
};

const PaymentReceiptModal = props => {
  const { trackIdPayment, contractId } = props;
  const [valid, setValid] = useState(ValidationTypes.UNSURE);
  const history = useHistory();
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(true);
  const [errors, setErrors] = useState([]);
  const [details, setDetails] = useState(null);

  const current = useSelector((state) => state.contracts.current);

  const fetchDetail = () => {
    return new Promise((resolve, reject) => {
      return client().query({
        query: GET_BILL_DETAIL,
        variables: {
          trackidpayment: trackIdPayment,
          contractId: contractId,
        },
        fetchPolicy: "network-only",
      })
        .then(result => {
          return result;
        })
        .then(result => {
          console.log(result, '<------'); resolve(result);
        })
        .catch(error => {
          const errors = standardizeGraphQLError(error);
          reject(errors);
        })
    });
  }

  const closeModal = () => {
    setModalOpen(false);
    history.push('/bills');
  }

  useEffect(() => {
    if (!trackIdPayment) {
      history.push('/bills')
    }
    if (trackIdPayment && valid === ValidationTypes.UNSURE) {
      fetchDetail()
        .then(details => {
          console.log(details);
          if (details.data) {
            setValid(ValidationTypes.VALID);
            setDetails(details.data);
          }
        })
        .catch(errors => {
          setErrors([errors]);
          setValid(ValidationTypes.INVALID);
        });
    }
    // eslint-disable-next-line
  }, [trackIdPayment, history, valid])
  return valid === ValidationTypes.UNSURE ? null : (valid === ValidationTypes.INVALID ? (
    <div className="PaymentReceiptModal invalid" data-testid="PaymentReceiptModal">
      <PaymentModal
        isOpen={modalOpen}
        onClose={closeModal}
        desc={
          <div>
            <div className="payment-fail">
              <ul style={{ marginTop: 0, marginBottom: 0 }}>
                {
                  errors.map((err, i) => {
                    const { type, error: errorName } = err;
                    return type ? <li key={`error.${type}.${errorName}`}>{t(`bills.receipts.errors.${type}.${errorName}`)}</li>
                      : <li key={i}>{t("common.serverError")}</li>
                  })
                }
              </ul>
            </div>
          </div>
        }
        buttons={(
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Button
              onClick={closeModal}
              className="btn btn-primary"
            >
              {t("bills.receipts.back-to-bills")}
            </Button>
            <Button
              onClick={() => {
                setErrors([]);
                setValid(ValidationTypes.UNSURE);
                // fetchDetail();
              }}
              className="btn btn-primary"
            >
              {t("bills.receipts.update")}
            </Button>
          </div>
        )}
        icon="error"
        to={"/"}
        linkTitle={t("common.goToDashboard")}
        t={t}
        valid={valid}
        setErrors={setErrors}
        setValid={setValid}
      />
    </div>
  ) : (
      <div className="PaymentReceiptModal valid" data-testid="PaymentReceiptModal">
        {/*idIntegra*/}
        {/*contractIdIntegra*/}
        {/*idPaymentSetefi*/}
        {/*amountPayment*/}
        {/*businessName*/}
        {/*trackIdPayment*/}
        {/*bills {*/}
        {/*  id*/}
        {/*  date*/}
        {/*  amount*/}
        {/*}      */}

        <PaymentModal
          isOpen={modalOpen}
          onClose={closeModal}
          desc={
            <div>
              <div className="payment-fail">
                <p>{t("bills.pay.bills.success")}</p>
                <p>{t("bills.pay.bills.successBills")}</p>
                <div className="bills-paid">
                  <p className="font-bold">
                    {t("bills.pay.bills.contract")} {details && details.getPaymentDetail && details.getPaymentDetail.contractIdIntegra} - {current && current.clientId}</p>
                  <ul className="bill">
                    {details && details.getPaymentDetail.bills && details.getPaymentDetail.bills.map(({ id }, i) => {
                      return (
                        <li key={i} className="font-bold">
                          {t("bills.pay.invoiceNumber")} {id}
                        </li>
                      );
                    })}
                  </ul>
                  <p className="font-bold">
                    {t("bills.paidBills")}: {details && details.getPaymentDetail && details.getPaymentDetail.amountPayment}&euro;
                  </p>
                </div>
              </div>
            </div>
          }
          buttons={(
            <>
              <button
                onClick={closeModal}
                className="btn btn-primary"
              >
                {t("bills.receipts.back-to-bills")}
              </button>
            </>
          )}
          icon="success"
          to={"/"}
          linkTitle={t("common.goToDashboard")}
          t={t}
          valid={valid}
          setErrors={setErrors}
          setValid={setValid}
        />

      </div>
    ))
};

PaymentReceiptModal.propTypes = {
  trackIdPayment: PropTypes.string,
  contractId: PropTypes.string,
};

export default PaymentReceiptModal;
